<template>
  <div class="side-panel-container">
    <input style="display: none;" type="checkbox" id="side-checkbox" />
    <div class="side-panel" id="side-panel-right">
      <label @click="panelClosed()" class="side-button-2">+</label>
      <div id="side-panel-right-resizer"></div>
      <iframe id="side-iframe" src="" width="100%" height="100%"></iframe>
    </div>
  </div>
</template>

<script>

import {EventBus} from "@/eventBus";

export default {
  name: 'sidePanel',
  components: {},
  data() {
    return {
    }
  },
  methods: {
    openSidebar(link) {
      if ((typeof link) != "string") {
        return;
      }
      console.log("openSidebar0", link);
      link.replaceAll("&quot;", '"');
      if (link.includes("&")) {
        link += "&slim=1"
      } else {
        link += "?slim=1";
      }
      console.log("openSidebar1", link);
      if (document.getElementById('side-iframe').src === "") {
        document.getElementById("side-checkbox").checked = true;
        document.getElementById('side-iframe').src = link;
      } else {
        document.getElementById('side-iframe').setAttribute("src","");
        setTimeout(function () {
          document.getElementById("side-checkbox").checked = true;
          document.getElementById('side-iframe').setAttribute("src", link);
        }, 500);
      }
      return false;
    },
    panelClosed() {
      console.log('Panel closed');
      document.getElementById('side-iframe').setAttribute("src","");
      document.getElementById("side-checkbox").checked = false;
      EventBus.$emit('closedSidebar');
    },
  },
  created: function () {
    EventBus.$on("openSidebar", this.openSidebar);
  },
  destroyed() {
    EventBus.$off("openSidebar", this.openSidebar);
  },
}
</script>

<style>

i.fa.select-search-icon {
  display: inline;
  float: right;
  position: absolute;
  top: 11px;
  right: 28px;
  cursor: pointer;
  opacity: 0.5;
}
input.select-search-input {
  display: none;
}
input.select-search-input, input.select-search-input:focus, input.select-search-input:focus-visible {
  border: none;
  position: absolute;
  left: 8px;
  /*background: #fff0;*/
  top: 4px;
}
</style>